import { useState } from 'react'

import { Box, Button } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

import { useF25PricingContext } from 'modules/onboarding/components/Pricing/F25PricingContext'
import type Plan from 'modules/onboarding/lib/pricing/plans/Plan'

import ModuleCard from './_ModuleCard'

const ModulesList = () => {
  const [showAll, setShowAll] = useState(false)
  const {
    allPlans,
    configPlan: { recommendedAddons },
  } = useF25PricingContext()

  const toggleShowAll = () => {
    setShowAll((prev) => !prev)
  }

  const filteredAddons = allPlans.f25Addons.filter((addon) => {
    const plan = allPlans.f25Plans[0]
    const includedAddonsTitles =
      plan?.includedAddons?.map((includedAddon) => includedAddon.title) || []
    const includedExtraAddonsTitles =
      plan?.includedExtraAddons?.map((includedExtraAddon) => includedExtraAddon.title) || []

    return (
      !includedAddonsTitles.includes(addon.title) &&
      !includedExtraAddonsTitles.includes(addon.title)
    )
  })

  const addonsWithRecommendation = filteredAddons.map((plan: Plan) => {
    const isRecommended = recommendedAddons.some((recommended) =>
      plan.internalTitle.toLowerCase().includes(recommended)
    )
    return { plan, isRecommended }
  })

  const sortedAddons = addonsWithRecommendation.sort(
    (a, b) => Number(b.isRecommended) - Number(a.isRecommended)
  )

  const addons = showAll ? sortedAddons : sortedAddons.filter((e) => e.isRecommended)

  return (
    <Box gap="s24">
      {addons.map(({ isRecommended, plan }) => (
        <ModuleCard plan={plan} key={plan.title} isRecommended={isRecommended} />
      ))}
      <Button
        type="secondary"
        iconName={showAll ? 'chevron-up' : 'chevron-down'}
        onClick={toggleShowAll}
      >
        {showAll
          ? i18n.t('pricing_plans.toggle_modules_cta.hide')
          : i18n.t('pricing_plans.toggle_modules_cta.show')}
      </Button>
    </Box>
  )
}

export default ModulesList
